"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
const query_params_1 = require("./utils/query-params");
class MetadataClient extends authenticated_client_1.AuthenticatedClient {
    getDynamicVarKeys(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, from, to, searchSubstring } = request;
            const baseUrl = `/v1/projects/${projectId}/dynamicvar/keys`;
            const url = `${baseUrl}?${(0, query_params_1.makeQueryParams)({ from, to, searchSubstring })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getCustomVars(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, pageId } = request;
            const baseUrl = `/v1/projects/${projectId}/custom-vars`;
            const url = `${baseUrl}?${(0, query_params_1.makeQueryParams)({ pageId })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSegmentLimits() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/segment-limits`);
            return response.payload;
        });
    }
    getIntegrationEnrichmentValues(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = `/v1/projects/${request.projectId}/integration-enrichment/field-stats`;
            const response = yield this.httpPost(baseUrl, request);
            return response.payload;
        });
    }
}
exports.MetadataClient = MetadataClient;
//# sourceMappingURL=metadata.client.js.map